import { useMemo } from 'react';
import { RuntimeFilterOp } from '@thoughtspot/visual-embed-sdk/react';
import { getInfinityListPropsFromQuery, MultiSelectWithQueriesUrl } from 'shared/ui/MultiSelect';
import { ContractorCampaignsPageFilter, useGetCampaignsInfinityList } from 'entities/campaign';
import { FILTER_STYLES } from 'shared/constants';
import { ContractorReportsFilter } from 'entities/reports';

import { getCampaignsOptionsNameIdFromInfinite, useGetQueryParams, useGetServicesOptionsAliasId } from '../utils';
import { LiveboardEmbedConstructor } from '../LiveboardEmbedConstructor';

const LIVEBOARD_ID = '5623e062-d6c8-4951-8fb1-832d02d77707';

const selectedCampaignsQueryKey = ContractorReportsFilter.campaignsIdArray;

export function CampaignMap() {
  const servicesOptions = useGetServicesOptionsAliasId();

  const selectedCampaigns = useGetQueryParams(selectedCampaignsQueryKey);

  const getCampaignsFiltersQuery = useGetCampaignsInfinityList({
    isSyncedWithUrl: false,
    filterName: ContractorCampaignsPageFilter.campaignsIdArray,
    getFieldValueToShow: (item) => item.name,
  });

  const campaignsOptions = useMemo(() => {
    return getCampaignsOptionsNameIdFromInfinite(getCampaignsFiltersQuery.data);
  }, [getCampaignsFiltersQuery.data?.pages]);

  const getRuntimeFilters = () => {
    const runtimeFilters = [];

    if (selectedCampaigns.length && selectedCampaigns.length < campaignsOptions.length) {
      runtimeFilters.push({
        columnName: 'Campaign Name',
        operator: RuntimeFilterOp.IN,
        values: selectedCampaigns,
      });
    }

    return runtimeFilters;
  };

  const runtimeFilters = getRuntimeFilters();
  const shouldLoadLiveboard = selectedCampaigns.length > 0;

  if (!servicesOptions.length) {
    return null;
  }

  return (
    <LiveboardEmbedConstructor
      type="infobox"
      filters={
        <MultiSelectWithQueriesUrl.Select
          {...getInfinityListPropsFromQuery(getCampaignsFiltersQuery)}
          rootClassName={`${FILTER_STYLES.select} min-w-[310px]`}
          title="Campaign name"
          key="Campaign"
          options={campaignsOptions}
          filterName={selectedCampaignsQueryKey}
          isWhite
          isHighlighted={!selectedCampaigns.length}
          withCancel={false}
        />
      }
      title="Campaign expansion opportunities"
      liveBoardId={LIVEBOARD_ID}
      runtimeFilters={runtimeFilters}
      shouldLoadLiveboard={shouldLoadLiveboard}
      infoboxTitleText="Select a campaign to view your report."
      infoboxText="All data related to the selected campaign will be shown."
    />
  );
}
